import Backbone from 'backbone'
import template from './edit-profile.hbs'
import FormView from 'scoreboard/components/form-view'
import UserBasicsForm from 'scoreboard/admin/principals/users/user-basics-form'
import formHelper from 'scoreboard/components/form-helper'
import permissions from 'scoreboard/components/permissions'

const EditProfile = Backbone.View.extend({

	className: 'edit-profile',

	tagName: 'form',

	initialize: function() {
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		this.userBasicsForm = new UserBasicsForm({
			model: this.model,
			hideId: true
		})
		this.$('.dialog-body-content').append(this.userBasicsForm.el)
		this.userBasicsForm.render()
		this.formView.start()
		this.secure()

		return this
	},

	context: function() {
		let profileEditable = permissions.personalAccountInfo()
		let icon = profileEditable ? 'edit-flat' : null
		let header = profileEditable ?
			'common.user.currentUser.editProfile' :
			'common.user.currentUser.viewProfile'
		return {
			profileEditable,
			icon,
			header
		}
	},

	secure: function() {
		var adminReadOnly = this.model.get('username') === 'admin'
		if (adminReadOnly) {
			this.$('.user-basics-form').addClass('admin-read-only')
		}
	},

	submit: function() {
		var data = formHelper.readFromDom(this.el)
		return this.model.save(data, {
			success: function() {
				this.trigger('done')
			}.bind(this),
			error: function(model, xhr) {
				this.formView.error(xhr)
			}.bind(this)
		})
	},

	autoRemove: true
})

export default EditProfile
EditProfile.__filename__ = 'admin/principals/users/edit-profile.js'
